import { render, staticRenderFns } from "./upload3.vue?vue&type=template&id=133c75e8&scoped=true"
import script from "./upload3.vue?vue&type=script&lang=js"
export * from "./upload3.vue?vue&type=script&lang=js"
import style0 from "./upload3.vue?vue&type=style&index=0&id=133c75e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133c75e8",
  null
  
)

export default component.exports